(function () {
  const videoShows = document.querySelectorAll('[id^="liveshopping-"]');
  if (!window.initBambuserLiveShopping) {
    window.initBambuserLiveShopping = function (item) {
      window.initBambuserLiveShopping.queue.push(item);
    };
    window.initBambuserLiveShopping.queue = [];
    var scriptNode = document.createElement('script');
    scriptNode['src'] = 'https://lcx-embed.bambuser.com/default/embed.js';
    document.body.appendChild(scriptNode);
  }

  videoShows.forEach((videoShow) => {
    window.initBambuserLiveShopping({
      showId: videoShow.dataset.showId,
      node: videoShow,
      type: 'overlay',
    });
  });
})();
